import {CommonModule} from '@angular/common';
import {A11yModule} from '@angular/cdk/a11y';
import {NgModule} from '@angular/core';
import {SeFeAlertModule} from 'se-fe-alert';
import {SeFeAvatarModule} from 'se-fe-avatar';
import {SeFeButtonModule} from 'se-fe-button';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeFormFieldModule} from 'se-fe-form-field';
import {SeFeFormFieldOptionsModule} from 'se-fe-form-field-options';
import {SeFeFormFieldQuantityModule} from 'se-fe-form-field-quantity';
import {SeFeFormFieldSelectModule} from 'se-fe-form-field-select';
import {SeFeFormFieldTextModule} from 'se-fe-form-field-text';
import {SeFeFormServiceModule} from 'se-fe-form-service';
import {SeFeHeaderModule} from 'se-fe-header';
import {
  SeFeIconModule,
  seFeIconChevronDown,
  seFeIconChevronLeft,
  seFeIconChevronRight,
  seFeIconChevronUp,
  seFeIconClose,
  seFeIconDollarCircleOutline,
  seFeIconShoppingCart,
  seFeIconTrash,
  seFeSportIcons,
} from 'se-fe-icon';
import {SeFeInlineListModule} from 'se-fe-inline-list';
import {SeFeModalModule} from 'se-fe-modal';
import {SeFePageModule} from 'se-fe-page';
import {SeFeProgressBarModule} from 'se-fe-progress-bar';
import {SeFeSidePanelModule} from 'se-fe-side-panel';
import {SeFeSpinnerModule} from 'se-fe-spinner';
import {SeFeToastModule} from 'se-fe-toast';
import {SeFeOverlayModule} from 'se-fe-overlay';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeCarouselModule} from 'se-fe-carousel';

@NgModule({
  declarations: [],
  imports: [
    A11yModule,
    CommonModule,
    SeFeAlertModule,
    SeFeAvatarModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeCarouselModule,
    SeFeFormFieldModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldQuantityModule,
    SeFeFormFieldSelectModule,
    SeFeFormFieldTextModule,
    SeFeFormServiceModule,
    SeFeGridModule,
    SeFeHeaderModule,
    SeFeIconModule.include([
      seFeIconShoppingCart,
      seFeIconTrash,
      seFeIconDollarCircleOutline,
      seFeIconClose,
      seFeIconChevronDown,
      seFeIconChevronUp,
      seFeIconChevronLeft,
      seFeIconChevronRight,
      ...seFeSportIcons,
    ]),
    SeFeInlineListModule,
    SeFeModalModule,
    SeFeOverlayModule,
    SeFePageModule,
    SeFeProgressBarModule,
    SeFeSidePanelModule,
    SeFeSpinnerModule,
    SeFeToastModule,
  ],
  exports: [
    A11yModule,
    SeFeAlertModule,
    SeFeAvatarModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeCarouselModule,
    SeFeFormFieldModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldQuantityModule,
    SeFeFormFieldSelectModule,
    SeFeFormFieldTextModule,
    SeFeFormServiceModule,
    SeFeGridModule,
    SeFeHeaderModule,
    SeFeIconModule,
    SeFeInlineListModule,
    SeFeModalModule,
    SeFeOverlayModule,
    SeFePageModule,
    SeFeProgressBarModule,
    SeFeSidePanelModule,
    SeFeSpinnerModule,
    SeFeToastModule,
  ],
})
export class SeFeComponentsModule {}
